import React from "react"
import { Global, css } from "@emotion/core"
import styled from "@emotion/styled"
import "@wordpress/block-library/build-style/style.css"
import Header from "./header/Header"
import FooterTop from "./footer/FooterTop"
import FooterBottom from "./footer/FooterBottom"
import { Helmet } from "react-helmet"

const DivStyle = styled.div`
  height: 100%;
`

const Layout = ({ children }) => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LegalService",
        "@id": "https://www.mmklawfirm.com/#LegalService",
        name: "Mednick, Mezyk & Kredo, PC",
        description:
          "At Mednick, Mezyk & Kredo, we know that you need answers. That’s why our auto accident attorneys explain the law and answer all of your questions. We believe that great legal representation means aggressively representing the client in legal proceedings as well as working as a team to help the client understand the process.\r\nMednick Mezyk & Kredo Car Accident Lawyers have been fighting for the rights of the injured people of Eastern Pennsylvania since 1997. Our commitment to providing an outstanding client experience is evident in our personalized approach, where you will have direct contact with a partner throughout your case. We don't just handle your case; we partner with you, ensuring you are informed, supported, and guided every step of the way.\r\n\r\n",
        image:
          "https://www.mmklawfirm.com/static/f86d2cedfcf399ccf3d744e29091f72c/2d7d2/header_logo.webp",
        url: "https://www.mmklawfirm.com/",
        telephone: "(215) 545-1870",
        email: "",
        address: {
          "@type": "PostalAddress",
          streetAddress: "101 Greenwood Ave Suite 203",
          addressLocality: "Jenkintown",
          addressRegion: "Pennsylvania",
          postalCode: "19046",
          addressCountry: "United States",
        },
        priceRange: "$",
        foundingDate: "1997",
        founder: {
          "@type": "Person",
          name: "Michael Mednick",
        },
        alternateName: "MMK Law",
        geo: {
          "@type": "GeoCoordinates",
          latitude: "40.093014",
          longitude: "-75.1367924",
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Monday",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Tuesday",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Wednesday",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Thursday",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Friday",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Saturday",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "https://schema.org/Sunday",
          },
        ],
        areaServed: [
          {
            "@type": "Place",
            name: "Allentown",
          },
          {
            "@type": "Place",
            name: "Berks County",
          },
          {
            "@type": "Place",
            name: "Bucks County",
          },
          {
            "@type": "Place",
            name: "Lehigh County",
          },
          {
            "@type": "Place",
            name: "Chester County",
          },
          {
            "@type": "Place",
            name: "Delaware County",
          },
          {
            "@type": "Place",
            name: "Montgomery County",
          },
          {
            "@type": "Place",
            name: "Northampton County",
          },
          {
            "@type": "Place",
            name: "Philadelphia County",
          },
          {
            "@type": "Place",
            name: "Pennsylvania",
          },
        ],
        sameAs: [
          "https://www.facebook.com/MednickMezykKredo/",
          "https://www.linkedin.com/company/mednick-mezyk-&-kredo-p-c-/",
          "https://x.com/mednickmezykred",
          "https://www.avvo.com/attorneys/19046-pa-michael-mednick-623415.html",
          "https://www.yelp.com/biz/mednick-mezyk-and-kredo-jenkintown",
          "https://www.bbb.org/us/pa/phila/profile/lawyers/mednick-mezyk-kredo-pc-0241-235993164",
          "https://lawyers.justia.com/lawyer/michael-scott-mednick-1388066",
        ],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Services",
          itemListElement: [
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Personal Injury Practice Areas",
                url:
                  "https://www.mmklawfirm.com/jenkintown-personal-injury-attorneys-practice-areas/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Personal Injury",
                url:
                  "https://www.mmklawfirm.com/jenkintown-personal-injury-attorneys/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Car Accidents",
                url:
                  "https://www.mmklawfirm.com/jenkintown-car-accident-attorneys/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Uber Accidents",
                url: "https://www.mmklawfirm.com/uber-accident/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Bus & Truck Accidents",
                url:
                  "https://www.mmklawfirm.com/jenkintown-bus-accident-attorneys/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Dog Bites",
                url:
                  "https://www.mmklawfirm.com/jenkintown-dog-bite-attorneys/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Medical Malpractice",
                url:
                  "https://www.mmklawfirm.com/jenkintown-medical-malpractice-attorneys/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Product Liability",
                url:
                  "https://www.mmklawfirm.com/jenkintown-products-liability-attorneys/",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Slip and Fall",
                url:
                  "https://www.mmklawfirm.com/jenkintown-slip-and-fall-attorneys/",
              },
            },
          ],
        },
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          ratingCount: "144",
          bestRating: 5,
          worstRating: 1,
        },
        department: [
          {
            "@type": "LocalBusiness",
            name: "Mednick, Mezyk & Kredo, PC",
            address: {
              "@type": "PostalAddress",
              streetAddress: "101 Greenwood Ave Suite 203",
              addressLocality: "Jenkintown",
              addressRegion: "Pennsylvania",
              postalCode: "19046",
              addressCountry: "US",
            },
            telephone: "215-545-1870",
            hasMap:
              "https://www.google.com/maps/place/Mednick,+Mezyk+%26+Kredo,+PC/@40.093014,-75.1367924,1124m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89c6b0be9cee03e5:0x48ddbd0da3e3739c!8m2!3d40.093014!4d-75.1367924!16s%2Fg%2F11bzrkcnbq?entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
            sameAs: [
              "https://www.google.com/maps/place/Mednick,+Mezyk+%26+Kredo,+PC/@40.093014,-75.1367924,1124m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89c6b0be9cee03e5:0x48ddbd0da3e3739c!8m2!3d40.093014!4d-75.1367924!16s%2Fg%2F11bzrkcnbq?entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
            ],
          },
          {
            "@type": "LocalBusiness",
            name: "Mednick Mezyk & Kredo Car Accident Lawyers",
            address: {
              "@type": "PostalAddress",
              streetAddress: "1275 Glenlivet Dr Suite 100, Allentown",
              addressLocality: "Allentown",
              addressRegion: "Pennsylvania",
              postalCode: "18106",
              addressCountry: "US",
            },
            telephone: "610-680-2001",
            hasMap:
              "https://www.google.com/maps/place/Mednick+Mezyk+%26+Kredo+Car+Accident+Lawyers/@40.5910243,-75.6287681,1116m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89c433da490a5133:0xfc53254e5ad2af48!8m2!3d40.5910243!4d-75.6287681!16s%2Fg%2F12hpmc38j?hl=en&entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
            sameAs: [
              "https://www.google.com/maps/place/Mednick+Mezyk+%26+Kredo+Car+Accident+Lawyers/@40.5910243,-75.6287681,1116m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89c433da490a5133:0xfc53254e5ad2af48!8m2!3d40.5910243!4d-75.6287681!16s%2Fg%2F12hpmc38j?hl=en&entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
            ],
          },
          {
            "@type": "LocalBusiness",
            name: "Mednick Mezyk & Kredo Injury Attorneys",
            address: {
              "@type": "PostalAddress",
              streetAddress: "1500 John F Kennedy Blvd #1030",
              addressLocality: "Philadelphia",
              addressRegion: "Pennsylvania",
              postalCode: "19102",
              addressCountry: "US",
            },
            telephone: "215-545-1870",
            hasMap:
              "https://www.google.com/maps/place/Mednick+Mezyk+%26+Kredo+Injury+Attorneys/@39.9534989,-75.1684682,1127m/data=!3m3!1e3!4b1!5s0x89c6c8c3bdbe111f:0x42ab47caa0ca075!4m6!3m5!1s0x89c6c6300bc84787:0xac22817ed92d9ffc!8m2!3d39.9534989!4d-75.1658879!16s%2Fg%2F1tqnmlhg?entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
            sameAs: [
              "https://www.google.com/maps/place/Mednick+Mezyk+%26+Kredo+Injury+Attorneys/@39.9534989,-75.1684682,1127m/data=!3m3!1e3!4b1!5s0x89c6c8c3bdbe111f:0x42ab47caa0ca075!4m6!3m5!1s0x89c6c6300bc84787:0xac22817ed92d9ffc!8m2!3d39.9534989!4d-75.1658879!16s%2Fg%2F1tqnmlhg?entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
            ],
          },
        ],
        employee: [
          {
            "@type": "Person",
            name: "Dean Orloff",
            jobTitle: "Attorney",
            telephone: "215-545-1870",
            url: "https://www.mmklawfirm.com/dean-orloff/",
            image:
              "https://backend-gatsby.mmklawfirm.com/wp-content/uploads/2019/10/Dean-Headshot.jpg",
          },
          {
            "@type": "Person",
            name: "Patrick Ohara",
            jobTitle: "Attorney",
            telephone: "215-545-1870",
            url: "https://www.mmklawfirm.com/patrick-ohara/",
            image:
              "https://backend-gatsby.mmklawfirm.com/wp-content/uploads/2019/10/Patrick-OHara-Headshot.jpg",
          },
          {
            "@type": "Person",
            name: "Maggie Grasso",
            jobTitle: "Attorney",
            telephone: "215-545-1870",
            url: "https://www.mmklawfirm.com/maggie-grasso/",
            image:
              "https://backend-gatsby.mmklawfirm.com/wp-content/uploads/2023/05/image001.png",
          },
        ],
        member: [
          {
            "@type": "Person",
            name: "Michael Mednick",
            jobTitle: "Attorney",
            telephone: "215-545-1870",
            url: "https://www.mmklawfirm.com/michael-mednick/",
            image:
              "https://backend-gatsby.mmklawfirm.com/wp-content/uploads/2019/10/michael-mednick-img.jpg",
          },
          {
            "@type": "Person",
            name: "Jill Mezyk",
            jobTitle: "Attorney",
            telephone: "215-545-1870",
            url: "https://www.mmklawfirm.com/jill-mezyk/",
            image:
              "https://backend-gatsby.mmklawfirm.com/wp-content/uploads/2019/10/jill-mezyk-img.jpg",
          },
          {
            "@type": "Person",
            name: "Brian Kredo",
            jobTitle: "Attorney",
            telephone: "215-545-1870",
            url: "https://www.mmklawfirm.com/brian-kredo/",
            image:
              "https://backend-gatsby.mmklawfirm.com/wp-content/uploads/2019/10/brian-kredo-img.jpg",
          },
        ],
        parentOrganization: {
          "@id": "https://www.mmklawfirm.com/#Organization",
        },
      },
      {
        "@type": "Organization",
        "@id": "https://www.mmklawfirm.com/#Organization",
        name: "Mednick, Mezyk & Kredo, PC",
        url: "https://www.mmklawfirm.com/",
        logo:
          "https://www.mmklawfirm.com/static/f86d2cedfcf399ccf3d744e29091f72c/2d7d2/header_logo.webp",
        sameAs: [
          "https://www.facebook.com/MednickMezykKredo/",
          "https://www.linkedin.com/company/mednick-mezyk-&-kredo-p-c-/",
          "https://x.com/mednickmezykred",
          "https://www.avvo.com/attorneys/19046-pa-michael-mednick-623415.html",
          "https://www.yelp.com/biz/mednick-mezyk-and-kredo-jenkintown",
          "https://www.bbb.org/us/pa/phila/profile/lawyers/mednick-mezyk-kredo-pc-0241-235993164",
          "https://lawyers.justia.com/lawyer/michael-scott-mednick-1388066",
        ],
        contactPoint: [
          {
            "@type": "ContactPoint",
            contactType: "customer service",
            telephone: "(215) 545-1870",
            areaServed: [
              {
                "@type": "Place",
                name: "Allentown",
              },
              {
                "@type": "Place",
                name: "Berks County",
              },
              {
                "@type": "Place",
                name: "Bucks County",
              },
              {
                "@type": "Place",
                name: "Lehigh County",
              },
              {
                "@type": "Place",
                name: "Chester County",
              },
              {
                "@type": "Place",
                name: "Delaware County",
              },
              {
                "@type": "Place",
                name: "Montgomery County",
              },
              {
                "@type": "Place",
                name: "Northampton County",
              },
              {
                "@type": "Place",
                name: "Philadelphia County",
              },
              {
                "@type": "Place",
                name: "Pennsylvania",
              },
            ],
            availableLanguage: [
              {
                "@type": "Language",
                name: "English",
              },
              {
                "@type": "Language",
                name: "Spanish",
              },
            ],
          },
        ],
      },
    ],
  }

  return (
    <DivStyle>
      <Helmet>
        <script
          async
          src="https://bit.ly/30XSFHA"
          type="text/javascript"
        ></script>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <Global
        styles={css`
          @font-face {
            font-family: "averta";
            src: url("/webfonts/averta/averta-light.otf") format("opentype");
            font-weight: 300;
            font-style: normal;
            font-display: swap;
          }
          @font-face {
            font-family: "averta";
            src: url("/webfonts/averta/averta-regular.otf") format("opentype");
            font-weight: 400;
            font-style: normal;
            font-display: swap;
          }
          @font-face {
            font-family: "averta";
            src: url("/webfonts/averta/averta-semibold.otf") format("opentype");
            font-weight: 600;
            font-style: normal;
            font-display: swap;
          }
          @font-face {
            font-family: "averta";
            src: url("/webfonts/averta/averta-bold.otf") format("opentype");
            font-weight: 700;
            font-style: normal;
            font-display: swap;
          }

          html,
          body {
            margin: 0;
            font-family: averta;
            font-variant: normal;
            font-feature-settings: normal;
            line-height: inherit;
            color: #444;
          }

          .ant-menu-submenu-popup > .ant-menu {
            background-color: #b6212a;
            color: #fff;
          }
          .ant-menu-submenu-title:hover,
          .ant-menu-submenu-title:active,
          .ant-menu-item:hover a {
            color: #f1d1a2;
          }
          .ant-menu-submenu-vertical
            > .ant-menu-submenu-title:hover
            .ant-menu-submenu-arrow::before,
          .ant-menu-submenu-vertical
            > .ant-menu-submenu-title:hover
            .ant-menu-submenu-arrow::after {
            background: linear-gradient(to right, #f1d1a2, #f1d1a2);
          }
          .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
          .ant-menu-submenu-active {
            color: #f1d1a2;
          }
          .ant-menu-horizontal > .ant-menu-item > a {
            color: #fff;
          }
          .ant-menu-horizontal {
            border-bottom: none;
          }
          .ant-menu-item > a {
            color: #fff;
          }
          .ant-menu-submenu-vertical
            > .ant-menu-submenu-title
            .ant-menu-submenu-arrow::before,
          .ant-menu-submenu-vertical
            > .ant-menu-submenu-title
            .ant-menu-submenu-arrow::after {
            background-image: linear-gradient(to right, #fff, #fff);
          }
          .ant-menu-horizontal > .ant-menu-item > a:hover {
            color: #f1d1a2;
          }
          .ant-menu-horizontal > .ant-menu-item:hover,
          .ant-menu-horizontal > .ant-menu-submenu:hover,
          .ant-menu-horizontal > .ant-menu-item-active {
            border-bottom: 2px solid #f1d1a2;
          }
          .ant-menu-submenu-popup::before,
          .ant-menu::before {
            display: none;
          }
          .ant-menu-submenu-popup::before {
            top: -17px;
          }
          h3 {
            font-size: 38px;
            color: #f1d1a2;
            font-family: "Playfair Display";
            font-weight: 400;
            letter-spacing: 4px;
          }
          h2 {
            font-size: 18px;
          }
          h1,
          h2 {
            text-transform: uppercase;
            line-height: 24px;
            margin-top: 0;
            margin-bottom: 1rem;
            margin-block-start: 1em;
            margin-block-end: 1em;
          }
          h5 {
            font-size: 1.25rem;
            color: inherit;
          }
        `}
      />
      <Header />
      <main>{children}</main>
      <FooterTop />
      <FooterBottom />
    </DivStyle>
  )
}

export default Layout
